export const projects = [
    {
        title: 'Portfolio Website',
        description: 'Personal portfolio built with React, TypeScript, and Tailwind CSS.',
        stack: ['React', 'TypeScript', 'Tailwind'],
        link: '#'
    },
];
